import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import {
  addTickerSeries,
  cloneTickerSeries,
  confirmationRequest,
  fetchTickerSeries,
  setPageTitle,
  addUserReport,
} from "../../actions";
import { TICKER_SERIES_RESOURCE } from "../../api/resources";
import { AddSaveCancelWidget, Page, TickerSeriesList } from "../../components";
import Box from "../../components/layout/Box";
import { getTickerSeriesList, getProfile } from "../../selectors";

import "./styles.scss";
import { EmptyMessage } from "signoxe/components/widgets";

class TickerSeriesListPage extends React.Component {
  static propTypes = {
    profile: PropTypes.array.isRequired,
    addUserReport: PropTypes.func.isRequired,
    fetchTickerSeries: PropTypes.func.isRequired,
    addTickerSeries: PropTypes.func.isRequired,
    cloneTickerSeries: PropTypes.func.isRequired,
    confirmationRequest: PropTypes.func.isRequired,
    setPageTitle: PropTypes.func.isRequired,
    tickerSeries: PropTypes.array.isRequired,
    isFetching: PropTypes.bool.isRequired,
  };

  handleAddTickerSeries = (newName) =>
    this.props.addTickerSeries({ name: newName });

  handleCloneTickerSeries = (tickerSeries) =>
    this.props.cloneTickerSeries(tickerSeries);

  handleDeleteTickerSeries = (tickerSeries) => {
    const { profile } = this.props;
    if (profile && profile.features && profile.features.record_user_activity) {
      this.props.addUserReport({
        user: this.props.profile.id,
        action_type: "Delete",
        activity: `deleted (or attempt to delete) ticker series named  ${tickerSeries.name}`,
      });
    }

    this.props.confirmationRequest(
      "Ticker Series",
      `Deleting "${tickerSeries.name}" is a permanent action.
       This will delete all the tickers in this ticker series.
       If you want to delete an individual entry, click the delete icon next to it`,
      "DELETE",
      TICKER_SERIES_RESOURCE,
      tickerSeries.id
    );
  };

  componentDidMount() {
    // this.props.fetchTickerSeries();
    this.props.setPageTitle("Ticker Series");
  }

  render() {
    const { tickerSeries, profile} = this.props;
    const allowed_pages = profile && profile.allowed_pages
    const isNotAllowed = profile && allowed_pages && profile.allowed_pages.tickers_page


    return (
      <Page isNotAllowed={isNotAllowed} className="ticker-page">
        <Box direction="row">
          <AddSaveCancelWidget
            addLabel="Add Ticker Series"
            onSave={this.handleAddTickerSeries}
          />
        </Box>
        {!this.props.isFetching && this.props.tickerSeries.length === 0 ? (
          <EmptyMessage text="Your Ticker Series is empty. Please Add one!" />
        ) : (
          <TickerSeriesList
            tickerSeries={tickerSeries}
            onDelete={this.handleDeleteTickerSeries}
            onClone={this.handleCloneTickerSeries}
          />
        )}
      </Page>
    );
  }
}

export default connect(
  (state) => ({
    tickerSeries: getTickerSeriesList(state),
    profile: getProfile(state),
    isFetching: state.tickerSeries.isFetching,
  }),
  {
    fetchTickerSeries,
    addTickerSeries,
    cloneTickerSeries,
    setPageTitle,
    addUserReport,
    confirmationRequest,
  }
)(TickerSeriesListPage);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/TickerSeriesListPage/index.js